// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header_headerWrapper__f7Wsn","bgColor":"header_bgColor__znAnj","header":"header_header__PX_zJ"};